import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const signalFamilyMemberPrivacyDocumentUploaded = http.put<object, membershipApi.PrivacyDocumentUpdateRequest, object>(
  apiBaseUrl + '/familyMembers/:familyMemberId/documents/:documentId',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  () => {
    return HttpResponse.text(undefined, { status: 204 })
  },
)
